import { config } from 'react-spring';

export const TIME_UNTIL_CLOSE = 300;

export const upDown = {
  from: {
    opacity: 0,
    transform: 'translateY(300px)',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  enter: {
    opacity: 1,
    transform: 'translateY(0px)',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  leave: {
    opacity: 0,
    transform: 'translateY(300px)',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  config: config.gentle
};
